<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div class="bg-white rounded-xl shadow-2xl p-8 w-full max-w-lg relative">
      <button class="absolute bg-transparent border-0 outline-none top-2 right-4 text-gray-700 hover:text-black text-2xl admin-button--ghost admin-button--icon" aria-label="Schließen" title="Schließen" @click="$emit('close')">
        <i class="fa fa-xmark"></i>
      </button>
      <h2 class="text-xl font-bold mb-4">Training "{{ training.name }}" ausführen</h2>
      <form @submit.prevent="executeTraining">
        <div class="text-left mb-4">
          <label class="block font-semibold mb-1">Modus</label>
          <select v-model="options.mode" class="border rounded px-3 py-2 w-full mb-2">
            <option value="single">Einzelner Mitarbeiter</option>
            <option value="multi">Mehrere Persnr eingeben</option>
          </select>
          <label>Datum</label>
          <input type="date" v-model="options.date" class="border rounded px-3 py-2 w-full mb-2">
          <div v-if="options.mode === 'single'">
            <label class="block font-semibold mb-1">Mitarbeiter</label>
            <select v-model="user" class="border rounded px-3 py-2 w-full">
              <option v-for="el in users" :value="el.persnr" :key="el.id">{{el.displayName}}</option>
            </select>
          </div>
          <div v-else>
            <label class="block font-semibold mb-1">Persnr-Liste (Komma- oder Zeilen-getrennt)</label>
            <textarea v-model="persnrList" class="w-full border rounded px-2 py-1" rows="3" placeholder="z.B. PSL10001, PSL10002 oder eine Persnr pro Zeile"></textarea>
          </div>
        </div>
        <div v-if="template">
          
        <div v-for="ph in template.placeholders" :key="ph" class="mb-4 text-left">
          <label class="block font-semibold mb-1">{{ ph }}</label>
          <div class="flex gap-2">
            <select v-model="placeholderModes[ph]" class="border rounded px-2 py-1 w-32">
              <option value="static">Statisch</option>
              <option value="variable">Variable</option>
            </select>
            <input v-if="placeholderModes[ph]==='static'" type="text" v-model="values[ph]" class="flex-1 border rounded px-2 py-1" :placeholder="'Wert für '+ph" required />
            <select v-else v-model="placeholderVariables[ph]" class="flex-1 border rounded px-2 py-1">
              <option v-for="v in availableVariables" :value="'v_'+v.replace(' ', '_')" :key="v">{{ v }}</option>
            </select>
          </div>
        </div>
      </div>

        <div class="flex justify-end gap-2 mt-6">
          <button type="button" class="bg-gray-300 text-gray-700 rounded px-4 py-2 admin-button--secondary" @click="$emit('close')">Abbrechen</button>
          <button type="submit" class="bg-green-600 text-white rounded px-4 py-2 admin-button--primary">Erstellen</button>
        </div>
      </form>
      <Spinner v-if="generating"/>
  </div>
</div>
</template>



<script>
import CASP from '@/CASP.js';
import Spinner from "@/components/Spinner.vue"
export default {
  name: 'ExecuteTrainingModal',
  props: {
    templates: { type: Array, required: false },
    training: { type: Object, required: true },
  },
  components:{Spinner},
  data() {
    return {
      values: {},
      template: null,
      users: [],
      user: 0,
      generating: false,
      options: {
        mode: 'single',
        target: 0,
        date: new Date().toISOString().split('T')[0]
      },
      placeholderModes: {},
      placeholderVariables: {},
      availableVariables: ['Vorname', 'Nachname', 'Personalnummer', 'Geburtsdatum', 'Strasse', 'PLZ', 'Stadt', 'PLZ Stadt']
    };
  },
  methods: {
    getUsers() {
      CASP.getUsers("",(result) => {
        this.users = result || [];
      });
    },
    executeTraining() {
      // Werte für alle Platzhalter sammeln
      const getValuesForPlaceholders = () => {
        const out = {};
        if(!this.template || !this.template.placeholders){
          return out;
        }
        for (const ph of this.template.placeholders) {
          if (this.placeholderModes[ph] === 'variable') {
            out[ph] = this.placeholderVariables[ph] || '';
          } else {
            out[ph] = this.values[ph] || '';
          }
        }
        return out;
      };
      this.generating = true;
      if(this.options.mode === 'multi'){
        this.options.target = this.persnrList.split(/,|\n|;/).map(x => x.trim()).filter(x => x.length > 0)
      }else{
        this.options.target = [this.user]
      }
      CASP.executeTraining(this.training.id, {options: this.options, values: getValuesForPlaceholders()}, (status, res) => {
          this.generating = false;
          if (status == 200 && res) {
            this.$emit('executed');
          } else {
            alert('Generierung fehlgeschlagen!');
          }
          this.generating = false;
        });
    },
  },
  mounted() {
    if(this.training.templateId ){
      this.template = this.templates.find(t => t.id == this.training.templateId);
    }
    this.getUsers();
    // Initialisiere placeholderModes und placeholderVariables (Vue 3 kompatibel)
    if (this.template && this.template.placeholders) {
      const modes = {};
      const vars = {};
      for (const ph of this.template.placeholders) {
        modes[ph] = 'static';
        vars[ph] = this.availableVariables[0];
      }
      this.placeholderModes = modes;
      this.placeholderVariables = vars;
    }
  }
};
</script>

<style scoped>
</style>
